import { useEffect, useRef } from 'react';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import type { IUseSetMarkersOptions } from 'components/map/map-container/hooks/types.ts';

export const useSetMarkers = ({ map, getMarkers, withCluster = false }: IUseSetMarkersOptions) => {
  const markersRef = useRef<google.maps.marker.AdvancedMarkerElement[]>([]);
  const polyLinesRef = useRef<google.maps.Polyline[]>([]);
  const clusterRef = useRef<MarkerClusterer | null>(null);

  useEffect(() => {
    if (map) {
      getMarkers({ markersRef, polyLinesRef });

      if (withCluster && !clusterRef.current) {
        clusterRef.current = new MarkerClusterer({ markers: markersRef.current, map });
      } else if (withCluster) {
        clusterRef.current?.addMarkers(markersRef.current);
      }
    }

    return () => {
      clusterRef.current?.clearMarkers();

      markersRef.current.forEach((marker) => {
        marker.map = null;
      });

      polyLinesRef.current.forEach((marker) => {
        marker.setMap(null);
      });

      markersRef.current = [];
      polyLinesRef.current = [];
    };
  }, [getMarkers, map]);
};
